/*
  Coduri aplicate automat de site, pentru campaniile 1+1 pe cod (El Clasico, codul CLASICO, 23–25.10.2026: reducerile
  automate Shopify sunt 25/25, deci 1+1 e un cod BXGY).

  Lista vine din snippets/tuju-campaigns.liquid (mode 'gate'), randată doar cât e activă campania:
    <script type="application/json" id="tuju-auto-codes">[{ "id", "code", "min", "ids": [product ids] }]</script>

  - După orice modificare a coșului, oriunde pe site (butonul temei, quick add, perechile, ofertele din coș), se citește
    coșul (no-store). Dacă are cel puțin `min` bucăți eligibile (fără abonament) și codul nu e pe coș, se aplică:
    întâi /discount/<cod> (ca linkurile de campanie), verificat în /cart.js; dacă nu ține, /cart/update.js cu codurile
    existente + codul (codurile se cumulează: ACASA30 pe alte produse rămâne).
  - Modificările coșului se văd cu PerformanceObserver pe resursele /cart/add|change|update|clear (fetch și XHR),
    fără să atingem codul temei.
  - Fiecare stare a coșului (cod + bucăți + produse) se încearcă o singură dată: dacă Shopify refuză codul, nu buclă.
  - După aplicare: coșul lateral și header-ul se re-randează prin tuju-cart-offers (window.__tujuCartSync); pe /cart
    pagina se reîncarcă.
  - window.__tujuAutoCode.check({ sync }) → Promise cu coșul (sau null), pentru perechile de pe pagina de produs.
  - dataLayer: cart_code_apply (source: 'auto').
*/
(function () {
  if (window.__tujuAutoCode) return;
  var node = document.getElementById('tuju-auto-codes');
  var list = [];
  try { list = JSON.parse(node ? node.textContent : '[]') || []; } catch (e) { list = []; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var tried = {};
  var running = null;

  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      });
  }
  // Pagina servită din cache după finalul campaniei: modul 'gate' a pus deja tuju-off-<id> pe <html>.
  function isOff(c) {
    return document.documentElement.classList.contains('tuju-off-' + c.id);
  }
  function hasCode(cart, code) {
    return (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code; });
  }
  function eligible(cart, c) {
    return (cart.items || []).filter(function (i) {
      return !i.selling_plan_allocation && c.ids.indexOf(Number(i.product_id)) > -1;
    });
  }
  function units(lines) {
    return lines.reduce(function (s, i) { return s + i.quantity; }, 0);
  }
  function apply(code) {
    return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'),
      { cache: 'no-store', credentials: 'same-origin' })
      .catch(function () {})
      .then(getCart)
      .then(function (cart) {
        if (hasCode(cart, code)) return cart;
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; })
          .filter(function (d) { return String(d).toUpperCase() !== code; });
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.concat([code]).join(',') })
        }).then(getCart);
      });
  }

  function check(opts) {
    var sync = !opts || opts.sync !== false;
    if (running) return running;
    running = getCart()
      .then(function (cart) {
        var todo = null, lines = [];
        list.some(function (c) {
          if (!c || !c.code || !Array.isArray(c.ids) || isOff(c)) return false;
          lines = eligible(cart, c);
          if (units(lines) >= (c.min || 2) && !hasCode(cart, c.code)) { todo = c; return true; }
          return false;
        });
        if (!todo) return cart;
        var key = todo.code + ':' + lines.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
        if (tried[key]) return cart;
        tried[key] = true;
        var before = cart.total_discount || 0;
        return apply(todo.code).then(function (after) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'cart_code_apply', code: todo.code, campaign: todo.id, source: 'auto',
            success: hasCode(after, todo.code), saving: ((after.total_discount || 0) - before) / 100
          });
          if (sync) {
            if (/\/cart\/?$/.test(location.pathname)) location.reload();
            else if (typeof window.__tujuCartSync === 'function') window.__tujuCartSync(after);
          }
          return after;
        });
      })
      .catch(function () { return null; })
      .then(function (cart) { running = null; return cart; });
    return running;
  }

  window.__tujuAutoCode = { check: check };
  if (!list.length) return;

  var timer = 0;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { check(); }, 400);
  }
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (entries) {
        entries.getEntries().forEach(function (e) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name)) schedule();
        });
      }).observe({ type: 'resource' });
    } catch (e) {}
  }
  // Coșul adus de pe altă pagină sau de dinaintea campaniei.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
